import {useContext} from 'react';
import {companyRegistrationFormSubmittingContext} from '../company-registration-form-root';
import styles from './form-submit-button.module.css';

export function FormSubmitButton() {
  const isSubmitting = useContext(companyRegistrationFormSubmittingContext);

  return (
    <button type='submit' className={styles.button} disabled={isSubmitting}>
      入力内容を確認する
    </button>
  );
}
